import { render, staticRenderFns } from "./DateDialog.vue?vue&type=template&id=0a573fc9&scoped=true&"
import script from "./DateDialog.vue?vue&type=script&lang=js&"
export * from "./DateDialog.vue?vue&type=script&lang=js&"
import style0 from "./DateDialog.vue?vue&type=style&index=0&id=0a573fc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a573fc9",
  null
  
)

export default component.exports